import {ChevronDown} from 'lucide-react';
import {useTranslation} from 'react-i18next';

import {AvatarWithLabel} from '@/components/ui/avatar-label';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {useSignOut} from '@/hooks/useAuth';
import {useMyUser} from '@/hooks/useUsers';

const MyAccountDropdown = () => {
  const {t} = useTranslation();
  const name = useMyUser();
  const signOut = useSignOut();

  const avatarUrl = name?.userInfo?.avatar;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="rounded-full bg-white p-1 shadow-subtle" tabIndex={0}>
          <AvatarWithLabel
            src={avatarUrl || undefined}
            fallback={name?.initials || ''}
            color="secondary"
            layout="inline"
            className="cursor-pointer"
            label={
              <div className="flex flex-row items-center gap-1 max-sm:hidden">
                <span className="text-secondary-800">
                  {t('Hello')}, {name?.firstName}!
                </span>
                <span className="flex size-8 items-center justify-center rounded-full bg-neutral-light">
                  <ChevronDown className="text-neutral-dark" size={20} />
                </span>
              </div>
            }
          />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="bottom" align="end">
        <DropdownMenuItem
          onClick={() => {
            signOut.mutate();
          }}
        >
          {t('Log out')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default MyAccountDropdown;
